import { vec3 } from 'gl-matrix'
import gsap from 'gsap'

import Deferred from '@/webgl/core/Deferred'
import IAnimationTrack from '@/webgl/runner/interfaces/IAnimationTrack'
import PlayerRenderer from '@/webgl/runner/rendering/PlayerRenderer'

type PlayerRevealOptions = {
  delay: number
  reverse: boolean
  duration: number
}

export default class PlayerRevealAnimation implements IAnimationTrack {
  initialScale: vec3 = vec3.create()
  options: PlayerRevealOptions

  public constructor(
    private player: PlayerRenderer,
    options: Partial<PlayerRevealOptions> = {}
  ) {
    this.options = {
      delay: 0,
      reverse: false,
      duration: 0.5,
      ...options,
    }
  }

  init(): void {
    this.player.node.setScale(this.options.reverse ? 0 : 1)
  }

  play(): Promise<unknown> {
    const defer = new Deferred<void>()
    const o = { scale: this.options.reverse ? 1 : 0 }
    gsap.to(o, {
      scale: this.options.reverse ? 0 : 1,
      duration: this.options.duration,
      delay: this.options.delay,
      onUpdate: () => this.player.node.setScale(o.scale),
      onComplete: () => defer.resolve(),
    })
    return defer.promise
  }
}
